import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-4 text-center mt-6">
      <p>© 2025 ग्रामपंचायत वलनी
 | संपर्क: 9049752529</p>
    </footer>
  );
};

export default Footer;